import { Stack, Typography, useTheme } from "@mui/material";
import { CopyIcon, InfoIcon, Input } from "components";
import toast from "react-hot-toast";

export const CopyOidcUrl = ({ redirectUrl }: { redirectUrl: string }) => {
  const theme = useTheme();
  const containerStyles = {
    padding: "16px 24px",
    border: `1px solid ${theme.palette.neutral["010"]}`,
    borderRadius: "8px",
    bgcolor: theme.palette.neutral.main,
  };

  const copyRedirectUrl = async () => {
    try {
      await navigator.clipboard.writeText(redirectUrl);
      toast.success("Redirect URL copied to clipboard");
    } catch (error) {
      toast.error("Failed to copy to clipboard");
    }
  };

  return (
    <Stack
      sx={{
        gap: "12px",
        bgcolor: theme.palette.neutral["005"],
        height: "100%",
      }}
    >
      <Stack
        sx={{
          gap: "8px",
          ...containerStyles,
        }}
      >
        <Typography variant="subtitle1">Redirect URL</Typography>
        <Input
          name={"redirect-url"}
          InputProps={{
            endAdornment: (
              <CopyIcon
                style={{
                  width: "16px",
                  height: "16px",
                  cursor: "pointer",
                }}
                onClick={copyRedirectUrl}
              />
            ),
          }}
          value={redirectUrl}
        />
      </Stack>
      <Stack
        direction="row"
        alignItems="flex-start"
        p="12px 16px"
        gap="8px"
        border="1px solid #98C6F1"
        bgcolor="#E8F3FE"
        borderRadius="8px"
      >
        <InfoIcon
          color="info"
          style={{
            width: "24px",
            height: "24px",
          }}
        />
        <Stack gap="16px">
          <Typography variant="subtitle1" color="#0075C8">
            To set up SSO, make sure to add the redirect URL shown above to your
            identity provider (Azure Entra or Google Workspace).
          </Typography>
          <Stack gap="8px">
            <Typography variant="caption-2">For Azure Entra</Typography>
            <Stack
              component="ol"
              sx={{
                paddingLeft: "16px",
                margin: 0,
                gap: "4px",
              }}
            >
              <Typography variant="body-small" component="li">
                Click <strong>Redirect URLs</strong>
              </Typography>
              <Typography variant="body-small" component="li">
                Select <strong>Add a platform</strong> — a side drawer will open
              </Typography>
              <Typography variant="body-small" component="li">
                Choose <strong>Web</strong>
              </Typography>
              <Typography variant="body-small" component="li">
                Click <strong>Configure</strong>
              </Typography>
              <Typography variant="body-small" component="li">
                Click <strong>Add URL</strong> and enter the redirect URL shown
                above
              </Typography>
            </Stack>
          </Stack>
          <Stack gap="8px">
            <Typography variant="caption-2">For Google Workspace</Typography>
            <Stack
              component="ol"
              sx={{
                paddingLeft: "16px",
                margin: 0,
                gap: "4px",
              }}
            >
              <Typography variant="body-small" component="li">
                Click <strong>Redirect URLs</strong>
              </Typography>
              <Typography variant="body-small" component="li">
                Under <strong>Authorized redirect URIs</strong>, add the
                redirect URL shown above
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};
